export const MASTER_CHART_HEIGHT = 264;
export const INDIVIDUAL_CHART_HEIGHT = 216;
